export default "__VITE_ASSET__DYWB2xRF__"